import { FlexContainer } from '../../containers/ContentContainers/FlexContainer';
import { IconLibrary } from '../IconLibrary/IconLibrary';
import { IconName } from '../IconLibrary/iconLibraryTypes';
import Typography from '@mui/material/Typography';

type ICON_SIZE = 24 | 32 | 40 | 48;
type METRIC_VALUE_FONT_SIZE = 24 | 28 | 32 | 36;
type METRIC_SIZE = 'sm' | 'md' | 'lg' | 'xl';

type METRIC_SIZE_CONFIG = {
  iconSize: ICON_SIZE;
  metricValueFontSize: METRIC_VALUE_FONT_SIZE;
};

const METRIC_SIZE_MAP: Record<METRIC_SIZE, METRIC_SIZE_CONFIG> = {
  sm: {
    iconSize: 40,
    metricValueFontSize: 24,
  },
  md: {
    iconSize: 40,
    metricValueFontSize: 28,
  },
  lg: {
    iconSize: 48,
    metricValueFontSize: 32,
  },
  xl: {
    iconSize: 48,
    metricValueFontSize: 36,
  },
} as const;

interface SimpleMetricProps {
  iconName: IconName;
  metricValue: number | string;
  metricSize?: METRIC_SIZE;
}

export const SimpleMetric = ({
  iconName = 'User',
  metricValue = 0,
  metricSize = 'lg',
}: SimpleMetricProps) => {
  const { iconSize, metricValueFontSize } = METRIC_SIZE_MAP[metricSize];
  return (
    <FlexContainer
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap={1}
      padding="0 0 8px 0"
      overflow="hidden"
      overflowY="hidden"
      overflowX="hidden"
    >
      <IconLibrary iconName={iconName} weight="regular" size={iconSize} />
      <Typography variant="bodyLarge" fontSize={metricValueFontSize}>
        {metricValue}
      </Typography>
    </FlexContainer>
  );
};
